import { useMutation } from '@tanstack/react-query'

import type { AddSteeringRangeRequest } from '@/features/resource/endpoints/resources'
import { addSteeringRange } from '@/features/resource/endpoints/resources'

export function useAddSteeringRangeMutation(resourceId: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (data: AddSteeringRangeRequest) => addSteeringRange(resourceId, data),
  })

  return {
    addSteeringRange: mutateAsync,
    ...mutationResult,
  }
}
